ACC.addressDoctorCheckout = {
    _autoload: [
        ['init', document.querySelector('.checkout-template .js-address-doctor')],
    ],
    selectedSavedCardId: null,
    isSavedFlow: false,
    placeOrderBtn: '.cs_btn-place-order, .btn-place-order',

    init() {
        const { bindPlaceOrderClick, bindSaveCardsClick } = ACC.addressDoctorCheckout;
        bindPlaceOrderClick();
        bindSaveCardsClick();
    },

    bindPlaceOrderClick() {
        const { placeOrderBtn, handleAddressDoctorRequest } = ACC.addressDoctorCheckout;

        document.querySelector(placeOrderBtn).addEventListener('click', (event) => {
            event.preventDefault();
            if (ACC.addressDoctorHED.editedRecommendedAddress) {
                event.stopImmediatePropagation();
                ACC.buttonhelper.disable(placeOrderBtn);
                handleAddressDoctorRequest(event);
            }
        });
    },

    bindSaveCardsClick() {
        const cardsContainer = document.querySelector('#savedPaymentCards');
        if (cardsContainer) {
            cardsContainer.addEventListener('click', ({ target }) => {
                const { showAddressDoctorBlock, clearNewCreditCardForm } = ACC.addressDoctorHED;
                const { removeAddCardTextFromAD } = ACC.addressDoctorCheckout;

                if (target.id === 'savedCard-newCard') {
                    clearNewCreditCardForm();
                    showAddressDoctorBlock(false);
                    removeAddCardTextFromAD();
                }

                if (target.tagName !== 'INPUT'
                    || target.classList.contains('input')
                    || target.id === 'savedCard-newCard') return;
                ACC.addressDoctorCheckout.selectedSavedCardId = +target.dataset.savedcardid;
                showAddressDoctorBlock(false);
            });
        }
    },

    handleAddressDoctorRequest() {
        const {
            fetchAddressDoctor,
            bindOriginalAddressTemplateEvents,
            setRecommendedAddresses,
            setOriginalAddresses,
            showAddressDoctorBlock,
            setReenterAddress,
            showReenterAddressDoctorBlock,
            handlerChange,
        } = ACC.addressDoctorHED;

        const {
            bindRecommendedTemplateEvents,
            bindReenterAddressButton,
            onLoadMoveAddCardTextToAD,
            placeOrderBtn,
        } = ACC.addressDoctorCheckout;

        fetchAddressDoctor($('#billingAddressFormContainer'))
            .then((response) => {
                if (response.isValid) {
                    ACC.secureacceptance.handlerPlaceOrderBtn();
                    return;
                }

                if (!response.suggestedAddresses.length) {
                    setReenterAddress(response.originAddress);
                    bindReenterAddressButton();
                    bindOriginalAddressTemplateEvents();
                    showReenterAddressDoctorBlock(true);
                    onLoadMoveAddCardTextToAD();
                    handlerChange();
                    ACC.buttonhelper.enable(placeOrderBtn);
                    return;
                }
                setRecommendedAddresses(response.suggestedAddresses);
                setOriginalAddresses(response.originAddress);
                showAddressDoctorBlock(true);
                onLoadMoveAddCardTextToAD();
                bindRecommendedTemplateEvents({
                    suggestedAddresses: response.suggestedAddresses,
                    userForm: $('#billingAddressFormContainer'),
                });
                bindOriginalAddressTemplateEvents();
                ACC.buttonhelper.enable(placeOrderBtn);
            })
            .catch(() => {
                ACC.buttonhelper.enable(placeOrderBtn);
                ACC.secureacceptance.handlerPlaceOrderBtn();
            });
    },

    bindRecommendedTemplateEvents({ suggestedAddresses, userForm }) {
        const {
            elements: { recommendedADBtnClass },
        } = ACC.addressDoctorHED;
        const {
            savedCardFlow,
            newCardFlow,
            selectedSavedCardId,
        } = ACC.addressDoctorCheckout;
        const recommendedAddressBtn = document.querySelectorAll(recommendedADBtnClass);
        const { setSelectedRecommendedAddress } = ACC.addressDoctorCheckout;
        const newCardRadioBtn = document.querySelector('#savedCard-newCard');
        const useDeliveryAddressCheckbox = document.querySelector('#useDeliveryAddress');

        recommendedAddressBtn.forEach((item) => item.addEventListener('click', (event) => {
            event.preventDefault();
            ACC.buttonhelper.disable(recommendedAddressBtn);
            const id = event.target.getAttribute('data-id');
            const selectedAddress = suggestedAddresses.find((address, index) => index === Number(id));

            if (selectedSavedCardId) {
                savedCardFlow(selectedAddress, userForm);
            } else {
                newCardFlow(selectedAddress, userForm);
            }
            if (newCardRadioBtn.checked && useDeliveryAddressCheckbox && useDeliveryAddressCheckbox.checked) {
                setSelectedRecommendedAddress(selectedAddress);
            }
        }));
    },

    newCardFlow(selectedAddress, userForm) {
        const {
            handlerChange,
            setDataToUserForm,
            showAddressDoctorBlock,
        } = ACC.addressDoctorHED;
        setDataToUserForm(selectedAddress, userForm);
        handlerChange();
        ACC.addressDoctorHED.editedRecommendedAddress = false;
        showAddressDoctorBlock(false);
    },

    savedCardFlow(selectedAddress, userForm) {
        const { showAddressDoctorBlock } = ACC.addressDoctorHED;
        const { showNewCreditCardFormSavedFlow } = ACC.addressDoctorCheckout;

        ACC.addressDoctorHED.editedRecommendedAddress = false;
        showNewCreditCardFormSavedFlow(selectedAddress, userForm);
        showAddressDoctorBlock(false);
    },

    showNewCreditCardFormSavedFlow(selectedAddress, userForm) {
        const {
            handlerChange,
            setDataToUserForm,
            fillExpDateNewCreditCardForm,
        } = ACC.addressDoctorHED;
        const label = document.querySelector('#savedPaymentCards label[data-radio="newCard"]');
        const cardAccountNumber = document.querySelector('#newCreditCardFormId #card_accountNumber');

        ACC.addressDoctorCheckout.isSavedFlow = true;

        if (label) {
            label.click();
            setDataToUserForm(selectedAddress, userForm);
            handlerChange();
            fillExpDateNewCreditCardForm(ACC.addressDoctorCheckout.selectedSavedCardId);
            ACC.addressDoctorCheckout.selectedSavedCardId = null;
            cardAccountNumber.focus();
        }
    },

    bindReenterAddressButton() {
        const { showReenterAddressDoctorBlock, elements: { reenterADBtnClass } } = ACC.addressDoctorHED;
        const reenterAddressBtn = document.querySelector(reenterADBtnClass);
        const useDeliveryAddressCheckbox = document.querySelector('#useDeliveryAddress');
        const newCardRadioBtn = document.querySelector('#savedCard-newCard');
        const form = document.querySelector('#billingAddressFormContainer');

        reenterAddressBtn.addEventListener('click', () => {
            const isDeliveryAddressChecked = useDeliveryAddressCheckbox && useDeliveryAddressCheckbox.checked;
            if (newCardRadioBtn.checked && !isDeliveryAddressChecked) {
                form.scrollIntoView({
                    behavior: 'smooth',
                });
            } else if (!newCardRadioBtn.checked) {
                newCardRadioBtn.click();
                newCardRadioBtn.scrollIntoView({
                    behavior: 'smooth',
                });
            } else if (newCardRadioBtn.checked && isDeliveryAddressChecked) {
                useDeliveryAddressCheckbox.click();
                form.scrollIntoView({
                    behavior: 'smooth',
                });
            }
            showReenterAddressDoctorBlock(false);
            ACC.addressDoctorHED.editedRecommendedAddress = true;
        });
    },

    onLoadMoveAddCardTextToAD() {
        const savedCards = document.querySelectorAll('.c-saved-card');

        if (savedCards.length) {
            savedCards.forEach((elem) => {
                if (elem.classList.contains('selected')) {
                    ACC.addressDoctorCheckout.moveAddCardTextToAD();
                }
            });
        }
    },

    moveAddCardTextToAD() {
        const savedCardAddYourCardAgain = $('.savedCardAddYourCardAgain');
        savedCardAddYourCardAgain.parent().insertAfter('.js-reenter-address-doctor');
        savedCardAddYourCardAgain.parent().addClass('has-margin-bottom--30 has-margin-top--30');
        document.querySelectorAll('.inline-address-doctor').forEach((elem) => {
            elem.classList.add('has-margin-top--30');
        });
    },

    removeAddCardTextFromAD() {
        $('.savedCardAddYourCardAgain').parent().appendTo('#savedCardBillingAddress');
    },

    setSelectedRecommendedAddress(selectedAddress) {
        document.querySelector('#ccDeliveryAddress').innerHTML = `
            ${selectedAddress.firstName} ${selectedAddress.lastName}
            <br>
            ${selectedAddress.line1} ${selectedAddress.line2 || ''}
            <br>
            ${selectedAddress.town}, ${selectedAddress.region.name}
            <br>
            ${selectedAddress.postalCode}
            <br>
            ${selectedAddress.country.name}
            <br>
            ${selectedAddress.phone}
        `;
    },
};
